import classNames from 'classnames'
import { Status } from 'feature/statuses/types'

import style from './EmailStatus.module.scss'

type EmailStatusProps = {
  status: Status
  statusText: string
}
// статус email
export function EmailStatus({ status, statusText }: EmailStatusProps) {
  return (
    <span className={classNames(style[status], style.status)}>
      {statusText}
    </span>
  )
}
